// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__16JOi","pageHeaderText":"PageHeader_pageHeaderText__bFrNI"};